import { _ as a } from "./index860.mjs";
import { _ as s } from "./index861.mjs";
import { i as e } from "./index785.mjs";
var i = a, y = s, k = e;
function m(r) {
  return k(r) ? i(r) : y(r);
}
var p = m;
export {
  p as k
};
